import { AdvisorBubble, Column, FormUnit } from '@/components'
import { AssessmentStepKeys } from '@/enums'
import { useFormItem, useNextLoading, useOnNextClick } from '@/providers'
import { Alert } from '@surein/ui'
import { TriangleAlert } from 'lucide-react'
import { Trans, useTranslation } from 'react-i18next'
import { useSaveAssessmentStep, useStepperWarning } from '../helpers'
import { StepperTestimonial } from './StepperTestimonial'

interface ApproxRevenueStepProps {
  helperText?: string
}

export const ApproxRevenueStep = ({ helperText }: ApproxRevenueStepProps) => {
  const { save, isLoading } = useSaveAssessmentStep(
    AssessmentStepKeys.approxRevenue,
  )

  const { t } = useTranslation()

  const { value } = useFormItem('approxTurnover')

  const { shouldShowWarning } = useStepperWarning(value)

  useOnNextClick(save)

  useNextLoading(() => isLoading, [isLoading])

  return (
    <Column gap="24px">
      <FormUnit
        helperText={helperText}
        name="approxTurnover"
        placeholder={t('currencyInputPlaceholder')}
        unit="€"
      />
      {shouldShowWarning && (
        <Alert
          icon={TriangleAlert}
          // @ts-expect-error change type in surein alert component
          text={<Trans i18nKey="approxRevenueWarning" />}
          variant="warning"
        />
      )}
      <AdvisorBubble text={t('approxRevenueAdvisorHint')} />
    </Column>
  )
}

export const ApproxRevenueStepTestimonial = () => (
  <StepperTestimonial stepKey="approxRevenue" imageSrc="emily-headshot" />
)
